import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
        this.navState();
        this.smoothScroll();
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });

        window.addEventListener("onRefresh", () => {
            ScrollTrigger.refresh();
        });

        //parallax
        const prxelm = [...document.querySelectorAll(".js-prx")];

        prxelm.forEach((elm) => {
            const y = elm.getAttribute("data-y") || -100;

            gsap.to(elm, {
                y: y,
                scrollTrigger: {
                    trigger: elm,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 0.5,
                    //markers: true,
                },
            });
        });
    }

    navState() {
        //初期化
        document.body.classList.add("-gnav_hidden");

        //スクロールでのグロナビのIN OUT
        if (window.innerWidth >= 835) {
            window.addEventListener("scroll", () => {
                if (window.scrollY > 100) {
                    document.body.classList.remove("-gnav_hidden");
                } else {
                    document.body.classList.add("-gnav_hidden");
                }
            });
        } else {
            const bnr = document.querySelector(".sidebnr_mv");

            if (bnr) {
                const rect = bnr.getBoundingClientRect();
                const h = window.scrollY + rect.top;

                //KVバナーが視界から消えたら出現
                window.addEventListener("scroll", () => {
                    if (window.scrollY > h) {
                        document.body.classList.remove("-gnav_hidden");
                    } else {
                        document.body.classList.add("-gnav_hidden");
                    }
                });
            }
        }

        //スクエニフッターが見えたら消えるように
        const sqFoot = document.querySelector("#sqexFooter");

        const options = {
            rootMargin: "0px",
            threshold: 0,
        };

        const obcb = (entries) => {
            // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    document.body.classList.add("-sq_in");
                } else {
                    document.body.classList.remove("-sq_in");
                }
            });
        };

        const observer = new IntersectionObserver(obcb, options);
        observer.observe(sqFoot);
    }

    smoothScroll() {
        const triggers = [...document.querySelectorAll(".js-smoothscroll")];
        const pagetop = [...document.querySelectorAll(".js-pagetop")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = window.innerWidth <= 768 ? window.innerWidth * 0.3 : 200 * (window.innerWidth / 1920);
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: "circ.inOut" });
            });
        });
    }
}
